import { useState } from "preact/hooks";
import { GET, GET_CHANGE_SPARE_OPTION } from "../../../services";
import { IStateSpareDevice } from "../interfaces/state";


export const useGetOption = () => {
  const [optionsChangeDevice, setOptionsChangeDevice] = useState(
    [] as IStateSpareDevice[]
  );

  const onFetchOptionChangeDevice = async () => {
    try {
      const res = await GET(GET_CHANGE_SPARE_OPTION);
      const { options: optcd } = res.result;
      setOptionsChangeDevice(optcd);
    } catch (error) {
      console.log(error);
    }
  };
  return {
    onFetchOptionChangeDevice,
    optionsChangeDevice,
  };
};
